export const sideNavWidthXL = 530;
export const sideNavWidthLG = 530;
export const sideNavWidthMD = 380;
export const sideNavWidthSM = 320;
export const sideNavWidthCollapsed = 146;

export const contentWidth = 1128;
export const contentWidthSM = 634;
export const portraitOrientationQueryIPads =
  "@media only screen and (min-device-width : 768px) and (max-device-width : 1024px) and (orientation : portrait)";
